// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-openseadragon-action-buttons {
    top: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
    height: 47px;
    position: absolute;
    padding: 8px 16px;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 999;
    display: block;
    text-align: center;
}

.aiiif-openseadragon-action-buttons > div {
    text-align: center;
    flex-grow: 2;
    background-color: transparent;
}

.aiiif-openseadragon-action-buttons .aiiif-button-bar > button.active {
    background-color: transparent;
}

.aiiif-openseadragon-action-buttons button {
    border: none;
    background-color: transparent;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.54);
    font-size: 1.6rem;
    background-repeat: no-repeat;
    margin-left: 6px;
}

.aiiif-openseadragon-action-buttons button > a {
    font-size: 1.6rem;
}

.aiiif-openseadragon-action-buttons button:first-of-type {
    margin-left: 0;
}

.aiiif-openseadragon-action-buttons button:disabled svg {
    opacity: 0.6;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/viewer/image/imageButtons.css"],"names":[],"mappings":"AAAA;IACI,MAAM;IACN,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,0CAA0C;IAC1C,YAAY;IACZ,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,0BAA0B;IAC1B,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".aiiif-openseadragon-action-buttons {\n    top: 0;\n    left: 0;\n    right: 0;\n    box-sizing: border-box;\n    height: 47px;\n    position: absolute;\n    padding: 8px 16px;\n    background-color: rgba(255, 255, 255, 0.5);\n    z-index: 999;\n    display: block;\n    text-align: center;\n}\n\n.aiiif-openseadragon-action-buttons > div {\n    text-align: center;\n    flex-grow: 2;\n    background-color: transparent;\n}\n\n.aiiif-openseadragon-action-buttons .aiiif-button-bar > button.active {\n    background-color: transparent;\n}\n\n.aiiif-openseadragon-action-buttons button {\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    color: rgba(0, 0, 0, 0.54);\n    font-size: 1.6rem;\n    background-repeat: no-repeat;\n    margin-left: 6px;\n}\n\n.aiiif-openseadragon-action-buttons button > a {\n    font-size: 1.6rem;\n}\n\n.aiiif-openseadragon-action-buttons button:first-of-type {\n    margin-left: 0;\n}\n\n.aiiif-openseadragon-action-buttons button:disabled svg {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
